import {
  NAVIGATE_TO_CREATE_ITEM_PAGE,
  NAVIGATE_TO_FEED_PAGE,
  NAVIGATE_TO_LOGIN_PAGE,
  NAVIGATE_TO_SETTINGS_PAGE,
  NAVIGATE_TO_PREMIUM_PLANS_PAGE,
  NAVIGATE_TO_CREATE_LIST_PAGE
} from "./events"
import PAGES from "constants/pages"

export const EVENTS_ROUTES_MAP = {
  [NAVIGATE_TO_LOGIN_PAGE]: PAGES.login.path,
  [NAVIGATE_TO_SETTINGS_PAGE]: PAGES.settings.path,
  [NAVIGATE_TO_CREATE_ITEM_PAGE]: PAGES.item.path,
  [NAVIGATE_TO_CREATE_LIST_PAGE]: PAGES.list.path,
  [NAVIGATE_TO_FEED_PAGE]: PAGES.home.path,
  [NAVIGATE_TO_PREMIUM_PLANS_PAGE]: PAGES.premiumSubscription.path,
}
